import { connect } from '@vfde-sails/core';
import { toAddressString } from '@vfde-sails/avc-core';
import { mountFlagBadge, updatePrimaryFlagBadge, updateSecondaryFlagBadge } from '../../components/flagBadge';
import { AddressFormId, AvailabilityResultId, OXGAvailabilityIndicatorColor, PrimaryCardId, SecondaryCardId } from '../../enum';
import { mountButton, updateResultButton } from '../../components/button';
import { getResultCardConfig, getSecondaryResultCardConfig } from '../../util/cms';
import { setElementVisibility } from '../../util/visibility';
import { mountButtonLink } from '../../components/buttonLink';
import * as mapDispatch from '../AddressValidation/action';
import { toggleOverlay } from '../App/action';
import { mountHeadline, updateResultCardHeadline } from '../../components/headline';
import { mountJustText, updateJustText, updateSecondaryJustText } from '../../components/justText';
import { getUpdateFlags } from './update';
import { mapStateToProps } from './selector';
import { isOXGandConnected } from '../../util/jarvisHelpers';

const actionMap = {
    ...mapDispatch,
    toggleOverlay,
};

export type Actions = typeof actionMap;
export type State = ReturnType<typeof mapStateToProps>;
/**
 *
 * @param _state
 * @param actions
 * @returns
 */
function availabilityResult (_state: State, actions: Actions) {
    const primaryCard = {
        flagBadge: mountFlagBadge(PrimaryCardId.FLAGBADGE),
        headLine: mountHeadline(PrimaryCardId.HEADLINE),
        subline: mountJustText(PrimaryCardId.SUBLINE),
        button: mountButton(PrimaryCardId.BUTTON),
    };

    const secondaryCard = {
        flagBadge: mountFlagBadge(SecondaryCardId.FLAGBADGE),
        headLine: mountHeadline(SecondaryCardId.HEADLINE),
        subline: mountJustText(SecondaryCardId.SUBLINE),
        button: mountButton(SecondaryCardId.BUTTON),
    };

    const address = mountJustText(AvailabilityResultId.ADDRESS_TEXT);

    mountButton(AvailabilityResultId.MEDIA_TEXT_BUTTON, actions.toggleOverlay);
    mountButtonLink(AvailabilityResultId.CHANGE_BUTTON, actions.changeAddress);
    mountButtonLink(AvailabilityResultId.DELETE_BUTTON, actions.deleteAddress);

    return {
        getDerivedStateFromProps (newState: State, oldState: State) {
            const update = getUpdateFlags(newState, oldState);
            const { primary, secondary, selectedAddress, suggestions, isLeadManagement } = newState;

            if (update.primary && primary) {
                let config;

                if (isOXGandConnected(primary)) {
                    config = getResultCardConfig(OXGAvailabilityIndicatorColor.CONNECTED);
                } else {
                    config = getResultCardConfig(primary.type);
                }

                updatePrimaryFlagBadge(primaryCard.flagBadge, secondary?.type);
                updateResultCardHeadline(primaryCard.headLine, primary.product, config?.headline);
                updateJustText(primaryCard.subline, config?.subline);
                updateResultButton(primaryCard.button, primary.product?.id, config);
            }

            if (update.secondary && secondary) {
                const config = getSecondaryResultCardConfig(secondary);
                updateSecondaryFlagBadge(secondaryCard.flagBadge, secondary.type);
                updateResultCardHeadline(secondaryCard.headLine, secondary.product, config?.headline);
                updateSecondaryJustText(secondaryCard.subline, secondary.product, config);
                updateResultButton(secondaryCard.button, secondary.product?.id, config);
            }

            update.selectedAddress && updateJustText(address, toAddressString(selectedAddress));

            setElementVisibility(AddressFormId.WRAPPER, !suggestions);
            setElementVisibility(AvailabilityResultId.WRAPPER, suggestions);
            setElementVisibility(PrimaryCardId.WRAPPER, primary);
            setElementVisibility(SecondaryCardId.WRAPPER, secondary);
            setElementVisibility(AvailabilityResultId.MEDIA_TEXT, isLeadManagement);
        },
    };
}

export default connect(mapStateToProps, actionMap)(availabilityResult);
